// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IKv91","clinicsSelect":"styles_clinicsSelect__1_pW9"};